module.exports = __webpack_public_path__ + "static/media/ottawa-mobile.003d9f56.png";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/ottawa-mobile.png
// module id = 981
// module chunks = 0